var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.285156C6.71596 0.285156 0 7.00112 0 15.2852C0 23.5692 6.71596 30.2852 15 30.2852C23.284 30.2852 30 23.5692 30 15.2852C30 7.00112 23.284 0.285156 15 0.285156ZM10.9615 22.2082H8.07692V11.8236H10.9615V22.2082ZM9.51058 10.6698H9.49442C8.63365 10.6698 8.07692 10.0282 8.07692 9.22689C8.07692 8.40823 8.65096 7.78516 9.52731 7.78516C10.4048 7.78516 10.9454 8.40823 10.9615 9.22689C10.9615 10.0277 10.4048 10.6698 9.51058 10.6698ZM21.9231 22.2082H19.0385V17.0159C19.0385 15.2852 18.2042 14.7082 17.3077 14.7082C16.474 14.7082 15.5769 15.2852 15.5769 17.0159V22.2082H12.6923V11.8236H15.5769V13.5544C15.7748 12.9884 16.7215 11.8236 18.4615 11.8236C20.7692 11.8236 21.9231 13.5544 21.9231 16.439V22.2082Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.39f13aafe166f64006da3c38bc904075.svg";
export { ForwardRef as ReactComponent };